module.exports = __webpack_public_path__ + "img/passo_0.1f576854.png";